var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('Title',{staticClass:"has-text-centered"}),_c('Social',{staticClass:"has-text-centered"}),_c('div',{staticClass:"columns is-variable is-12 margin-top"},[_c('MarkdownBlogs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }